import React, { useState } from "react";
import { Provider } from "./Provider";
import { CountDown } from "../../services/helper";

export default function AdminLogin(props) {
  const {
    setUserName,
    setPassword,
    handleSubmit,
    errors,
    attempt,
    setAttempt,
    isLoading,
  } = Provider();

  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleTheme = () => setIsDarkMode(!isDarkMode);

  return (
    <div
      className={`flex justify-center items-center min-h-screen px-4 font-Poppins sm:px-6 lg:px-8 transition-all duration-300 ${
        isDarkMode ? "bg-gray-900 text-gray-200" : "bg-gray-100 text-gray-900"
      }`}
    >
      <div className="w-full max-w-md space-y-8">
        <div className="flex flex-col items-center">
          <div
            className={`w-16 h-16 rounded-full flex items-center justify-center ${
              isDarkMode ? "bg-gray-800" : "bg-[#eea900]"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6"
            >
              <path
                fillRule="evenodd"
                d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold font-poppins">
            Admin Login
          </h2>
        </div>
        <form className="mt-8 space-y-6" noValidate>
          <div className="rounded-md shadow-sm space-y-6">
            <div>
              <label htmlFor="username" className="sr-only">
                User Name
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                className={`appearance-none relative block w-full px-3 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#eea900] focus:border-[#eea900] sm:text-sm ${
                  errors.username
                    ? "border-red-500"
                    : isDarkMode
                    ? "bg-gray-800 text-gray-200 border-gray-600"
                    : "bg-white border-gray-300"
                }`}
                placeholder="User Name"
                onChange={(e) => setUserName(e.target.value)}
              />
              {errors.username && (
                <p className="text-red-500 text-sm mt-1">{errors.username}</p>
              )}
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className={`appearance-none relative block w-full px-3 py-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#eea900] focus:border-[#eea900] sm:text-sm ${
                  errors.password
                    ? "border-red-500"
                    : isDarkMode
                    ? "bg-gray-800 text-gray-200 border-gray-600"
                    : "bg-white border-gray-300"
                }`}
                placeholder="Password"
                onChange={(e) => setPassword(e.target.value)}
              />
              {errors.password && (
                <p className="text-red-500 text-sm mt-1">{errors.password}</p>
              )}
            </div>
          </div>

          <div className="flex items-center justify-between mt-4">
            <div className="flex items-center">
              <input
                id="remember_me"
                name="remember_me"
                type="checkbox"
                className="h-4 w-4 text-[#eea900] focus:ring-[#eea900] border-gray-300 rounded"
              />
              <label
                htmlFor="remember_me"
                className="ml-2 block text-sm font-medium"
              >
                Remember me
              </label>
            </div>
          </div>

          {attempt && (
            <CountDown countdown={30} show={attempt} setShow={setAttempt} />
          )}

          <button
            type="button"
            onClick={handleSubmit}
            disabled={attempt || isLoading}
            className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-[#eea900] hover:bg-[#cc8a00] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#eea900] disabled:opacity-50"
          >
            {isLoading ? (
              <span className="flex items-center">
                <svg
                  className="animate-spin h-5 w-5 mr-2 text-black"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 100 8v4a8 8 0 01-8-8z"
                  ></path>
                </svg>
              </span>
            ) : (
              "Sign In"
            )}
          </button>
        </form>
      </div>

      <button
        onClick={toggleTheme}
        className="fixed bottom-4 right-4 bg-[#eea900] text-white p-3 rounded-full shadow-lg hover:bg-[#cc8a00] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#eea900]"
      >
        {isDarkMode ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="size-6"
          >
            <path d="M12 2.25a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0V3a.75.75 0 0 1 .75-.75ZM7.5 12a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0ZM18.894 6.166a.75.75 0 0 0-1.06-1.06l-1.591 1.59a.75.75 0 1 0 1.06 1.061l1.591-1.59ZM21.75 12a.75.75 0 0 1-.75.75h-2.25a.75.75 0 0 1 0-1.5H21a.75.75 0 0 1 .75.75ZM17.834 18.894a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 1 0-1.061 1.06l1.59 1.591ZM12 18a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-2.25A.75.75 0 0 1 12 18ZM7.758 17.303a.75.75 0 0 0-1.061-1.06l-1.591 1.59a.75.75 0 0 0 1.06 1.061l1.591-1.59ZM6 12a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2.25A.75.75 0 0 1 6 12ZM6.697 7.757a.75.75 0 0 0 1.06-1.06l-1.59-1.591a.75.75 0 0 0-1.061 1.06l1.59 1.591Z" />
          </svg>
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="size-6"
          >
            <path
              fillRule="evenodd"
              d="M9.528 1.718a.75.75 0 0 1 .162.819A8.97 8.97 0 0 0 9 6a9 9 0 0 0 9 9 8.97 8.97 0 0 0 3.463-.69.75.75 0 0 1 .981.98 10.503 10.503 0 0 1-9.694 6.46c-5.799 0-10.5-4.7-10.5-10.5 0-4.368 2.667-8.112 6.46-9.694a.75.75 0 0 1 .818.162Z"
              clipRule="evenodd"
            />
          </svg>
        )}
      </button>
    </div>
  );
}
